module.exports = __webpack_public_path__ + "static/media/d7.674a23c8.png";